// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const env = process.env.APP_ENV || 'local';

if (env !== 'local') {
  Sentry.init({
    dsn: SENTRY_DSN || 'https://974d3824f28e412d82590b22c4c7f153@o153965.ingest.sentry.io/1299956',
    environment: env,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  });
}
